/*Redux store 생성하는 함수를 모듈화*/
import { createStore , applyMiddleware } from 'redux';
import rootReducer from "./reducer/index.js";
import {thunk} from 'redux-thunk'

// Redux 스토어 생성
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;